const init = () => {

	// Create MutationObserver to monitor class changes on html
	const mo = new MutationObserver(handleHtmlClassMutation);
	mo.observe(document.documentElement, {
		attributes: true,
		attributeFilter: ["class"]
	});

	// Create Intersection Observer to track when maps are visible
	const io = new IntersectionObserver(handleIntersectionChange);

	// Loop through map elements
	for (const m of document.querySelectorAll('[data-map]')) {

		// Watch map with IntersectionObserver
		io.observe(m);
	}
}

const handleHtmlClassMutation = (mutationsList) => {

	// For each observed mutation
	mutationsList.forEach((mutation) => {

		// Get mutation target
		const el = mutation.target;

		// If it contains the class that shows the maps script has loaded
		if (el.classList.contains(mapsScriptLoadedClass)) {

			for (const m of document.querySelectorAll('[data-map-loading]')) {

				loadMap(m);
			}
		}
	});
}

// Handles when intersection changes on map elements
const handleIntersectionChange = (entries) => {

	// For each map element
	entries.forEach(entry => {

		// If element is intersecting (i.e. is visible)
		if (entry.isIntersecting) {
			
			// Load map
			loadMap(entry.target);
		}
	});
}

const loadMap = (el) => {

	// If Google Maps script not yet available...
	if (typeof google !== 'object' || typeof google.maps !== 'object') {

		// Add attribute to map element to show that it's currently in process of loading.
		// This is used to target map once Google script loaded
		el.setAttribute('data-map-loading', '');

		// Create script tag to load it
		const s = document.createElement('script');
		s.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + googleCloudApiKey + '&callback=handleGMapsLoaded');
		document.documentElement.appendChild(s);

		return false;
	}

	// Check if map already loaded
	if (el.hasAttribute('data-map-loaded') === false) {

		// Get ID of map
		const mapId = el.getAttribute('data-map');
			
		// Create map
		const map = new google.maps.Map(
			el,
			{
				center: {
					lat: 0,
					lng: 0
				},
				styles: [
					{
						featureType: 'poi.business',
						stylers: [
							{
								"visibility": "off"
							}
						]
					}
				]
			}
		);

		const infoWindow = new google.maps.InfoWindow({});

		// Check if origin coords supplied
		if (el.hasAttribute('data-map-origin')) {

			// Separate origin coords into array
			const arrOrigin = el.getAttribute('data-map-origin').split(',');

			// Attach marker to map
			const marker = new google.maps.Marker({
				position: {
					lat: parseFloat(arrOrigin[0]),
					lng: parseFloat(arrOrigin[1])
				},
				map: map,
				title: "Your location",
			});
		}

		map.addListener('bounds_changed', () => {

			// If map not yet set as 'loaded'
			if (el.hasAttribute('data-map-loaded') === false) {

				// Get map zoom level
				const z = map.getZoom();
				
				// If zoomed in too far initially, set to sensible level
				if (z > 17) {
					map.setZoom(17);
				}

				// Remove 'loading' attr and add 'loaded' attr
				el.removeAttribute('data-map-loading');
				el.setAttribute('data-map-loaded', '');
			}
		});

		// Check for any map data
		if (typeof mapData !== undefined) {

			// Try to find marker data in mapData based on id
			const markersData = mapData.find(({ id }) => id === mapId);

			// If marker data found...
			if (markersData !== undefined) {
				
				// Create bounds object
				let bounds = new google.maps.LatLngBounds();

				// Loop through marker data
				for (const markerData of markersData.markers) {

					// Define marker position
					const markerPos = {
						lat: parseFloat(markerData.lat),
						lng: parseFloat(markerData.lng)
					};

					// Attach marker to map
					const marker = new google.maps.Marker({
						position: markerPos,
						map: map,
						title: markerData.name,
						icon: assetsBaseUrl + 'img/' + markerData.icon + '?v=2'
					});
					
					// Set content of info window when marker clicked
					marker.addListener('click', (e) => {
						infoWindow.setContent(markerData.info);
						infoWindow.open(map, marker);
					});

					// Extend bounds based on marker position
					bounds.extend(markerPos);
				}

				// Fit map to all markers
				map.fitBounds(bounds, 100);
			}
		}
	}
}

export default init